import * as React from 'react'


export default class extends React.Component{

    render(){
        return (
            <div className="route-content container mb-4" style={{ marginTop:'40px' }}>
                { this.props.children }
            </div>
        )
    }

}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/components/route-container.tsx